__turbopack_context__.v({
  "cards": "_8mm4dq_cards",
  "container": "_8mm4dq_container",
  "containerCard": "_8mm4dq_containerCard",
  "h3Platform": "_8mm4dq_h3Platform",
  "image": "_8mm4dq_image",
  "imageContainer": "_8mm4dq_imageContainer",
  "pPlatform": "_8mm4dq_pPlatform",
  "paragraph": "_8mm4dq_paragraph",
  "rowEtc": "_8mm4dq_rowEtc",
  "textCategory": "_8mm4dq_textCategory",
  "textH2": "_8mm4dq_textH2",
  "title": "_8mm4dq_title",
});
